import { PropsWithChildren } from "react";

export const TableBody = ({
  dataTestid,
  children,
}: { dataTestid?: string } & PropsWithChildren) => (
  <tbody data-testid={dataTestid}>{children}</tbody>
);
